// eslint-disable-next-line banned-modules
'use strict';

import BaseModel from '@/classes/base.model';

const ProductsFormModel = BaseModel.extend({

	defaults() {
		return {
			page: 0,
			pageSize: 10,
			count: 0,
		};
	},

	toJSON() {
		const model = BaseModel.prototype.toJSON.call(this);
		delete model.count;
		if (model.contactPerson == null || model.contactPerson === '') delete model.contactPerson;
		if (model.contactPersonRef != null) {
			model.contactPerson = model.contactPersonRef;
			delete model.contactPersonRef;
		}
		return {
			parameters: model,
		};
	},

});

export default ProductsFormModel;
